import React from "react";
import { Routes, Route } from "react-router-dom";

import "./App.css";

import Navbar from "./pages/Navbar";
import Slideshow from "./pages/Slideshow";
import AboutUs from "./pages/AboutUs";
import Schemes from "./pages/Schemes";

import Footer from "./pages/Footer";
import Home from "./pages/Home";
import Gallery from "./pages/Gallery";
import Awards from "./pages/Awards";
import ExecutiveBoard from "./pages/ExecutiveBoard";
import DepartmentSchemesPage from "./pages/DepartmentSchemesPage"; // if you want this page
import GramPanchayatVibhag from "./pages/deparments/GrampanchayatVibhag";
import SecondaryEducationVibhag from "./pages/deparments/SecondaryEducationVibhag";
import DRDAVibhag from "./pages/deparments/DRDAVibhag";
import FinanceVibhag from "./pages/deparments/FinanceVibhag";
import SocialWelfareVibhag from "./pages/deparments/SocialWelfareVibhag";
import MahilaBalKalyanVibhag from "./pages/deparments/MahilaBalKalyanVibhag";
import PashusamvardhanVibhag from "./pages/deparments/PashusamvardhanVibhag";
import KrushiVibhag from "./pages/deparments/KrushiVibhag";
import GraminPaniPuravathaVibhag from "./pages/deparments/GraminPaniPuravathaVibhag";
import ArogyaVibhag from "./pages/deparments/ArogyaVibhag";
import JilhaPaniSwachhataMission from "./pages/deparments/JilhaPaniSwachhataMission";
import LaghuPaatbandhareVibhag from "./pages/deparments/LaghuPaatbandhareVibhag";

function App() {
  return (
    <div style={{ fontFamily: "'Ephesis'" }}>
      {/* Navbar is outside Routes to show on all pages */}
      <Navbar />

      <Routes>
        {/* Landing page shows Home + Gallery + Awards */}
        <Route
          path="/"
          element={
            <>
              <Slideshow />

              <Home />
              <Gallery />
              <Awards />
            </>
          }
        />

        {/* Separate pages */}
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/awards" element={<Awards />} />
        <Route path="/executive-board" element={<ExecutiveBoard />} />
        <Route path="/department-schemes" element={<DepartmentSchemesPage />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/schemes" element={<Schemes />} />
        <Route
          path="/department/gram-panchayat"
          element={<GramPanchayatVibhag />}
        />
        <Route
          path="/department/secondary-education"
          element={<SecondaryEducationVibhag />}
        />
        <Route path="/department/drda" element={<DRDAVibhag />} />
        <Route path="/department/finance" element={<FinanceVibhag />} />
        <Route path="/department/social-welfare" element={<SocialWelfareVibhag />} />
        <Route path="/department/mahila-bal-kalyan" element={<MahilaBalKalyanVibhag />} />
        <Route path="/department/pashusamvardhan" element={<PashusamvardhanVibhag />} />
        <Route path="/department/krushi" element={<KrushiVibhag />} />
        <Route path="/department/gramin-pani-puravatha" element={<GraminPaniPuravathaVibhag />} />
        <Route path="/department/arogya" element={<ArogyaVibhag />} />
          <Route path="/department/jilha-pani-swachhata" element={<JilhaPaniSwachhataMission />} />
          <Route path="/department/laghu-paatbandhare" element={<LaghuPaatbandhareVibhag />} />
      </Routes>

      {/* Footer is outside Routes to show on all pages */}
      <Footer />
    </div>
  );
}

export default App;
